import HttpClient from 'Api/HttpClient';
import CONFIG from 'Config';

const httpClientFirebase = new HttpClient('https://www.googleapis.com/identitytoolkit/v3');

export default class AuthFirebase {
  resetPassword(email) {
    return httpClientFirebase.post(
      `/relyingparty/getOobConfirmationCode?key=${CONFIG.fireBaseConfig.apiKey}`,
      {
        email,
        requestType: 'PASSWORD_RESET',
      },
    );
  }
}
